var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-wrap"},[_c('navigationBar',{attrs:{"contentText":_vm.navTitle}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }